<template>
  <!-- 用户注册页面 -->
  <div
    style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; overflow-y: scroll; overflow-x: hidden; -webkit-overflow-scrolling: touch; touch-action: pan-y;">
    <div style="padding: 1rem; min-height: 100vh; padding-bottom: 4rem;">
      <div class="max-w-md mx-auto pt-4 md:pt-8">
        <!-- 返回按钮 -->
        <router-link to="/"
          class="inline-flex items-center gap-2 text-text-helper hover:text-primary transition-all duration-200 hover:scale-105 mb-8">
          <img style="width: 60px;" src="../../assets/images/back_icon.png">
        </router-link>

        <!-- 背景装饰 -->
        <div class="absolute inset-0 -z-10">
          <div class="absolute inset-0 bg_leaves"></div>
        </div>
        <div class="absolute inset-0 -z-10">
          <div class="absolute inset-0 bg_link"></div>
        </div>

        <!-- 注册表单卡片 -->
        <div style="padding: 0.5rem;" :class="{ 'opacity-50 pointer-events-none': mustReadAgreement }">
          <!-- 强制阅读协议提示 -->
          <div v-if="mustReadAgreement" class="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-md">
            <div class="flex items-center gap-3">
              <n-icon size="20" class="text-blue-600">
                <InformationCircleOutline />
              </n-icon>
              <div>
                <h3 class="text-blue-800 font-semibold">Terms of Service Required</h3>
                <p class="text-blue-700 text-sm mt-1">
                  Please read and accept the Terms of Service in the popup window to continue with registration.
                </p>
              </div>
            </div>
          </div>

          <!-- 机构Logo -->
          <div class="mb-6">
            <!-- <div class="w-20 mx-auto flex items-center justify-center text-6xl font-bold text-color">
              VerdeX
            </div>
            <div class="text-lg text-center">
              CARBON EXCHANGE
            </div> -->
            <img class="w-60 mx-auto" src="../../assets/airlogo.png"/>
          </div>

          <!-- 标题 -->
          <h1 class="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-6">
            User Registration
          </h1>

          <!-- 注册表单 -->
          <form @submit.prevent="handleRegister" class="space-y-6">
            <!-- 邮箱输入框 -->
            <div>
              <label for="email" class="block text-sm font-semibold text-gray-700 mb-2">
                Email Address
              </label>
              <input id="email" v-model="form.email" type="email"
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent input-box"
                :class="{ 'border-red-500': errors.email }" placeholder="Enter your email address" required
                autocomplete="email">
              <div v-if="errors.email" class="text-red-500 text-sm mt-1">
                {{ errors.email }}
              </div>
            </div>

            <!-- 姓名输入框 -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label for="firstName" class="block text-sm font-semibold text-gray-700 mb-2">
                  First Name
                </label>
                <input id="firstName" v-model="form.firstName" type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent input-box"
                  :class="{ 'border-red-500': errors.firstName }" placeholder="Enter your first name" required
                  autocomplete="given-name">
                <div v-if="errors.firstName" class="text-red-500 text-sm mt-1">
                  {{ errors.firstName }}
                </div>
              </div>

              <div>
                <label for="lastName" class="block text-sm font-semibold text-gray-700 mb-2">
                  Last Name
                </label>
                <input id="lastName" v-model="form.lastName" type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent input-box"
                  :class="{ 'border-red-500': errors.lastName }" placeholder="Enter your last name" required
                  autocomplete="family-name">
                <div v-if="errors.lastName" class="text-red-500 text-sm mt-1">
                  {{ errors.lastName }}
                </div>
              </div>
            </div>

            <!-- 电话号码 -->
            <div>
              <label for="phone" class="block text-sm font-semibold text-gray-700 mb-2">
                Phone Number
              </label>
              <input id="phone" v-model="form.phone" type="tel"
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent input-box"
                :class="{ 'border-red-500': errors.phone }" placeholder="Enter your phone number" required
                autocomplete="tel">
              <div v-if="errors.phone" class="text-red-500 text-sm mt-1">
                {{ errors.phone }}
              </div>
            </div>

            <!-- 出生日期 -->
            <div>
              <label for="birthDate" class="block text-sm font-semibold text-gray-700 mb-2">
                Date of Birth
              </label>
              <div class="text-xs text-gray-500 mt-1">
                Please select your date of birth (you must bd at least 18 years old)
              </div>
              <input id="birthDate" v-model="form.birthDate" type="date"
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent input-box"
                :class="{ 'border-red-500': errors.birthDate }" required autocomplete="bday" lang="en"
                :placeholder="'YYYY-MM-DD'" :title="'Please select your date of birth'">
              <div v-if="errors.birthDate" class="text-red-500 text-sm mt-1">
                {{ errors.birthDate }}
              </div>
              
            </div>

            <!-- 密码输入框 -->
            <div>
              <label for="password" class="block text-sm font-semibold text-gray-700 mb-2">
                Password
              </label>
              <div class="relative">
                <input id="password" v-model="form.password" :type="showPassword ? 'text' : 'password'"
                  class="w-full px-3 py-2 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent input-box"
                  :class="{ 'border-red-500': errors.password }" placeholder="Enter your password" required
                  autocomplete="new-password">
                <button type="button"
                  class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                  @click="showPassword = !showPassword">
                  <n-icon size="18">
                    <EyeOutline v-if="!showPassword" />
                    <EyeOffOutline v-else />
                  </n-icon>
                </button>
              </div>

              <!-- 密码要求说明 -->
              <div class="mt-2">
                <p class="text-sm text-gray-600">Password requirements:</p>
                <ul class="mt-1 space-y-1">
                  <li class="text-xs flex items-center gap-2"
                    :class="hasUppercase ? 'text-green-600' : 'text-gray-400'">
                    <span>{{ hasUppercase ? '✓' : '✗' }}</span>
                    Contains uppercase letter
                  </li>
                  <li class="text-xs flex items-center gap-2"
                    :class="hasLowercase ? 'text-green-600' : 'text-gray-400'">
                    <span>{{ hasLowercase ? '✓' : '✗' }}</span>
                    Contains lowercase letter
                  </li>
                  <li class="text-xs flex items-center gap-2"
                    :class="hasMinLength ? 'text-green-600' : 'text-gray-400'">
                    <span>{{ hasMinLength ? '✓' : '✗' }}</span>
                    At least 8 characters
                  </li>
                </ul>
              </div>

              <div v-if="errors.password" class="text-red-500 text-sm mt-1">
                {{ errors.password }}
              </div>
            </div>

            <!-- 确认密码 -->
            <div>
              <label for="confirmPassword" class="block text-sm font-semibold text-gray-700 mb-2">
                Confirm Password
              </label>
              <input id="confirmPassword" v-model="form.confirmPassword" type="password"
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent input-box"
                :class="{ 'border-red-500': errors.confirmPassword }" placeholder="Confirm your password" required
                autocomplete="new-password">
              <div v-if="errors.confirmPassword" class="text-red-500 text-sm mt-1">
                {{ errors.confirmPassword }}
              </div>
            </div>

            <!-- 邀请码（可选） -->
            <div>
              <label for="inviteCode" class="block text-sm font-semibold text-gray-700 mb-2">
                Guarantee Code
              </label>
              <input id="inviteCode" v-model="form.inviteCode" type="text"
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent input-box"
                placeholder="Enter  Guarantee Code">
            </div>

            <!-- 用户协议复选框 -->
            <div>
              <div v-if="!currentAgreement && !agreementLoading"
                class="mb-3 p-3 bg-yellow-50 border border-yellow-200 rounded-md">
                <p class="text-sm text-yellow-800 mb-2">Terms of Service failed to load.</p>
                <button type="button" @click="reloadAgreement"
                  class="text-sm bg-yellow-600 text-white px-3 py-1 rounded hover:bg-yellow-700">
                  Reload Terms of Service
                </button>
              </div>

              <label class="flex items-start gap-3 cursor-pointer">
                <input v-model="form.agreeToTerms" type="checkbox" :disabled="true" required
                  class="mt-1 w-4 h-4 text-green-600 border-gray-300 rounded focus:ring-green-500"
                  :class="{ 'opacity-50 cursor-not-allowed': !agreementRead }">
                <span class="text-sm leading-relaxed">
                  I have read and agree to the
                  <button type="button" @click="showAgreementModal = true"
                    :disabled="!currentAgreement || mustReadAgreement"
                    class="hover:text-green-700 hover:underline font-medium disabled:text-gray-400 disabled:cursor-not-allowed">
                    Terms of Service
                  </button>
                  <span v-if="agreementRead" class="ml-1">
                    ✓ Agreement accepted
                  </span>
                  <span v-else-if="currentAgreement" class="text-blue-600 ml-1">
                    (Please read the agreement in the popup)
                  </span>
                  <span v-else class="text-red-500 ml-1">
                    (Terms of Service not loaded)
                  </span>
                </span>
              </label>
              <div v-if="errors.agreeToTerms" class="text-red-500 text-sm mt-1">
                {{ errors.agreeToTerms }}
              </div>
            </div>

            <!-- 注册按钮 -->
            <button type="submit"
              class="w-full btn-full-gree text-white py-3 px-4 rounded-md font-semibold focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              :disabled="loading || !isFormValid">
              <div v-if="loading" class="flex items-center justify-center gap-2">
                <n-spin size="small" />
                <span>Registering...</span>
              </div>
              <span v-else>Register Now</span>
            </button>

            <!-- 登录链接 -->
            <div class="text-center mt-4">
              <p class="text-gray-600 text-sm">
                Already have an account?
                <router-link to="/login" class="hover:underline font-medium">
                  Login Now
                </router-link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- 用户协议弹窗 -->
    <UserAgreementModal v-model:show="showAgreementModal" :agreement="currentAgreement" :loading="agreementLoading"
      :mandatory="mustReadAgreement" @agreement-read="handleAgreementRead" />


  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { NIcon, NSpin, useMessage } from 'naive-ui'
import { ArrowBack, EyeOutline, EyeOffOutline, InformationCircleOutline } from '@vicons/ionicons5'
import { useAuthStore, type UserAgreement } from '@/stores/auth'
import UserAgreementModal from '@/components/auth/UserAgreementModal.vue'

// 路由和消息
const router = useRouter()
const message = useMessage()
const authStore = useAuthStore()

// 表单数据
const form = ref({
  email: '',
  firstName: '',
  lastName: '',
  phone: '',
  birthDate: '',
  password: '',
  confirmPassword: '',
  inviteCode: '',
  agreeToTerms: false
})

// 表单状态
const loading = ref(false)
const agreementLoading = ref(false)
const showPassword = ref(false)
const showAgreementModal = ref(false)
const agreementRead = ref(false)
const errors = ref<Record<string, string>>({})
const currentAgreement = ref<UserAgreement | null>(null)
const mustReadAgreement = ref(true) // 强制阅读协议标志

// 密码验证
const hasUppercase = computed(() => /[A-Z]/.test(form.value.password))
const hasLowercase = computed(() => /[a-z]/.test(form.value.password))
const hasMinLength = computed(() => form.value.password.length >= 8)

// 表单验证
const isFormValid = computed(() => {
  return form.value.email &&
    form.value.firstName &&
    form.value.lastName &&
    form.value.phone &&
    form.value.birthDate &&
    form.value.password &&
    form.value.confirmPassword &&
    hasUppercase.value &&
    hasLowercase.value &&
    hasMinLength.value &&
    form.value.password === form.value.confirmPassword &&
    form.value.agreeToTerms &&
    agreementRead.value
})

// 监听密码变化，清除错误
watch(() => form.value.password, () => {
  if (errors.value.password) {
    errors.value.password = ''
  }
})

watch(() => form.value.confirmPassword, () => {
  if (errors.value.confirmPassword) {
    errors.value.confirmPassword = ''
  }
})

// 组件挂载时获取用户协议并强制显示弹窗
onMounted(async () => {
  try {
    agreementLoading.value = true
    console.log('开始获取用户协议...')
    currentAgreement.value = await authStore.fetchAgreement()
    console.log('用户协议获取结果:', currentAgreement.value)

    if (currentAgreement.value) {
      // 协议加载成功，延迟一点时间确保DOM渲染完成后显示弹窗
      setTimeout(() => {
        showAgreementModal.value = true
        console.log('用户协议弹窗已显示')
      }, 500)
    } else {
      message.error('Failed to load Terms of Service. Please refresh the page and try again.')
    }
  } catch (error) {
    console.error('Failed to fetch agreement:', error)
    message.error('Failed to fetch Terms of Service')
  } finally {
    agreementLoading.value = false
  }
})

/**
 * 验证表单数据
 */
const validateForm = (): boolean => {
  errors.value = {}

  // 邮箱验证
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!emailRegex.test(form.value.email)) {
    errors.value.email = 'Please enter a valid email address'
  }

  // 姓名验证
  if (form.value.firstName.length < 1) {
    errors.value.firstName = 'First name cannot be empty'
  }

  if (form.value.lastName.length < 1) {
    errors.value.lastName = 'Last name cannot be empty'
  }

  // 电话验证
  const phoneRegex = /^[\+]?[1-9][\d]{0,15}$/
  if (!phoneRegex.test(form.value.phone)) {
    errors.value.phone = 'Please enter a valid phone number'
  }

  // 出生日期验证
  const birthDate = new Date(form.value.birthDate)
  const today = new Date()
  const age = today.getFullYear() - birthDate.getFullYear()
  if (age < 18) {
    errors.value.birthDate = 'You must be at least 18 years old'
  }

  // 密码验证
  if (form.value.password.length < 8) {
    errors.value.password = 'Password must be at least 8 characters'
  } else if (!hasUppercase.value || !hasLowercase.value) {
    errors.value.password = 'Password must contain uppercase and lowercase letters'
  }

  // 确认密码验证
  if (form.value.password !== form.value.confirmPassword) {
    errors.value.confirmPassword = 'Passwords do not match'
  }

  // 协议验证
  if (!form.value.agreeToTerms) {
    errors.value.agreeToTerms = 'Please agree to the Terms of Service'
  } else if (!agreementRead.value) {
    errors.value.agreeToTerms = 'Please read the complete Terms of Service first'
  }

  return Object.keys(errors.value).length === 0
}

/**
 * 处理注册提交
 */
const handleRegister = async () => {
  // 首先检查协议是否已加载
  if (!currentAgreement.value) {
    message.error('Terms of Service not loaded, please refresh the page and try again')
    console.error('Agreement not loaded:', { currentAgreement: currentAgreement.value, agreementRead: agreementRead.value })
    return
  }

  if (!validateForm()) {
    return
  }

  loading.value = true

  try {
    const result = await authStore.register({
      email: form.value.email,
      password: form.value.password,
      password_confirmation: form.value.confirmPassword,
      first_name: form.value.firstName,
      last_name: form.value.lastName,
      phone: form.value.phone,
      birth_date: form.value.birthDate,
      invitation_code: form.value.inviteCode || undefined,
      agreement_consent: form.value.agreeToTerms,
      agreement_id: currentAgreement.value?.id || 0
    })

    console.log(result);

    if (result.success) {
      message.success('Registration successful! Please complete the carbon footprint questionnaire.')

      // 注册成功后跳转到问卷页面
      router.push('/questionnaire')
    } else {
      message.error(result.message || 'Registration failed')

      // 处理服务器验证错误
      if (result.errors) {
        Object.keys(result.errors).forEach(key => {
          const errorMessages = result.errors![key]
          errors.value[key] = Array.isArray(errorMessages) ? errorMessages[0] : errorMessages
        })
      }
    }
  } catch (error) {
    console.error('Registration error:', error)
    message.error('Registration failed, please try again later')
  } finally {
    loading.value = false
  }
}

/**
 * 处理用户协议阅读完成
 */
const handleAgreementRead = () => {
  agreementRead.value = true
  mustReadAgreement.value = false
  showAgreementModal.value = false
  // 自动勾选协议复选框
  form.value.agreeToTerms = true
  message.success('Agreement accepted! You can now proceed with registration.')
}

/**
 * 重新加载用户协议
 */
const reloadAgreement = async () => {
  try {
    agreementLoading.value = true
    console.log('重新加载用户协议...')
    currentAgreement.value = await authStore.fetchAgreement()
    console.log('用户协议重新加载结果:', currentAgreement.value)

    if (currentAgreement.value) {
      message.success('Terms of Service loaded successfully')
    } else {
      message.error('Failed to load Terms of Service. Please check your internet connection.')
    }
  } catch (error) {
    console.error('Failed to reload agreement:', error)
    message.error('Failed to reload Terms of Service')
  } finally {
    agreementLoading.value = false
  }
}
</script>